import {
  fetchProviderNotifications,
  markAllProviderNotificationsRead,
} from "@/api/providerDashboard";
import notificationsLifecycle from "@/controllers/notificationsLifecycle";
import moment from "moment";

export default {
  data() {
    return {
      notifications: [],
      loading: true,
    };
  },
  ...notificationsLifecycle,
  methods: {
    async loadNotifications() {
      this.loading = true;
      try {
        const res = await fetchProviderNotifications({ limit: 50 });
        if (res.data.status === 200) this.notifications = res.data.data;
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    async markAllRead() {
      try {
        await markAllProviderNotificationsRead();
        this.notifications.forEach((n) => {
          n.new = false;
        });
        this.$store.commit("SET_DASHBOARD_COUNTS", {
          unreadNotificationCount: 0,
        });
        this.$message.success("전체 읽음 처리되었습니다.");
      } catch (err) {
        console.error(err);
      }
    },
    formatTime(d) {
      const now = moment();
      const diff = moment.duration(now.diff(d));
      const mins = Math.floor(diff.asMinutes());
      if (mins < 1) return "방금 전";
      if (mins < 60) return `${mins}분전`;
      const hours = Math.floor(diff.asHours());
      if (hours < 24) return `${hours}시간전`;
      const days = Math.floor(diff.asDays());
      if (days < 7) return `${days}일전`;
      return moment(d).format("MM.DD");
    },
  },
};
